module.exports = __webpack_public_path__ + "static/media/tick.78e14579.ico";